module.exports = __webpack_public_path__ + "img/refund.0e43048a.svg";